<template>
  <div class="container-fluid" v-if="menu.draft_status == '1'">
    <div class="alert alert-info" role="alert">
      El menú ahora se encuentra en <b>modo borrador</b>.
      Puedes probar el menú con los nuevos cambios en página <a :href="getTestMenuUrl()" target="_blank">Sunrise</a> y
      <a :href="getAuraTestMenuUrl()" target="_blank">Aura</a>. <br>
      Puedes resolver el modo borrador haciendo click <a href="#" @click="resolveDraft()">aquí</a>.
      En ese caso los cambios se verían en produccion en un plazo máximo de una hora.
      <div v-if="waiting" class="spinner-border" role="status"></div>
    </div>
    <div v-if="errorMessage" class="alert alert-danger" role="alert">
      <p>{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import Url from '@/core/Url.js'
import axios from "axios";

export default {
  name: 'draf-message',
  emits: ['draft_resolved'],
  data() {
    return {
      waiting: false,
      errorMessage: "",
    };
  },
  props: {
    menu: {
      type: Object,
      default: {}
    }
  },
  methods: {
    getTestMenuUrl: function () {
      return Url.getTestMenuUrl(this.menu.id);
    },
    getAuraTestMenuUrl: function () {
      return Url.getAuraTestMenuUrl(this.menu.id);
    },
    getMenuDraftUrl: function () {
      return Url.getMenuDraftUrl();
    },
    resolveDraft: function () {
      this.waiting = true;
      let data = {'menu_id': this.menu.id, 'draft_status': 0};
      axios
          .put(this.getMenuDraftUrl(), data)
          .then(response => {
            if (response.data.result) {
              this.$emit('draft_resolved');
            } else {
              this.errorMessage = "Se ha producido un error al resolver el modo borrador.";
            }
          }).catch(() => {
        this.errorMessage = "Se ha producido un error al resolver el modo borrador.";

      }).finally(() => {
        this.waiting = false;
      });
    }
  }
}
</script>
